import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class StopAlvik extends ASTBlock {
    constructor(color) {
        super(color, "stop_alvik")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "stoppe die Bewegung %1",
            "args0": [{
                "type": "input_dummy",
                "name": "NAME"
            }],
            "previousStatement": null,
            "nextStatement": null
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}